/* Lista VIP -> RD Station.
   Mesmo mecanismo da página "em breve" que estava no ar (04/08/2026): o form visível é nosso,
   o do RD fica fora da tela e só cuida do envio (double opt-in, UTMs, event_id do Pixel/CAPI).
   Desde 30/09/2026 a página tem mais de um form visível (topo e fim da página) e pede
   e-mail + WhatsApp (nome desde 09/10/2026). Todos usam o MESMO form escondido do RD. */
(function(){
  if(window.__zvVip) return;          // o script pode vir em mais de uma seção
  window.__zvVip = true;

  var boxes = [].slice.call(document.querySelectorAll('.zv-rd-hidden'));
  var wraps = [].slice.call(document.querySelectorAll('[data-zv-vip]'));
  if(!boxes.length || !wraps.length) return;
  var box = boxes[0];
  boxes.slice(1).forEach(function(b){ b.parentNode.removeChild(b); }); // um form do RD só
  var RD_LIB = 'https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js';

  // --- M2: a pessoa nao sai mais da pagina.
  // Como o RD funciona por dentro: ele NAO submete o form nativamente. Ele cancela o submit,
  // valida, e manda um XHR para /v2/conversions. Na resposta, o proprio JS dele faz
  // window.location.href = json.redirect_to  -> e esse redirect que joga a pessoa no veritas.
  // Aqui a resposta e reescrita sem o redirect_to. A conversao acontece exatamente igual
  // (double opt-in inclusive, e o e-mail de confirmacao sai do mesmo jeito); o RD simplesmente
  // fica sem para onde navegar. Nada de token, honeypot ou payload e reimplementado aqui.
  (function(){
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      var isConv = typeof url === 'string' &&
                   /rdstation\.com/.test(url) && /conversions/.test(url);
      if(isConv){
        var xhr = this;
        // registrado aqui dentro do open, portanto ANTES do onreadystatechange do RD -> roda primeiro
        xhr.addEventListener('readystatechange', function(){
          if(xhr.readyState !== 4) return;
          var raw = '';
          try{ raw = xhr.responseText || ''; }catch(e){ raw = ''; }
          var clean = raw;
          try{ var j = JSON.parse(raw); delete j.redirect_to; clean = JSON.stringify(j); }catch(e){}
          try{
            Object.defineProperty(xhr, 'responseText', {configurable:true, get:function(){ return clean; }});
            Object.defineProperty(xhr, 'response',     {configurable:true, get:function(){ return clean; }});
          }catch(e){}
          var ok = xhr.status >= 200 && xhr.status < 300;
          document.dispatchEvent(new CustomEvent('zr:rd-done', {detail:{ok:ok, status:xhr.status, body:clean}}));
        });
      }
      return open.apply(this, arguments);
    };
  })();

  // O RD faz alert(thankyou_message) ao terminar. Sem o input, sem alert nativo do browser:
  // a confirmacao passa a ser o "Pronto!" da propria pagina.
  // Chamado no submit, NAO no load: o form do RD e injetado de forma assincrona e no load
  // esse input ainda nao existe. Mesma razao pela qual o fillHidden() roda no submit.
  function killThankyou(){
    var t = box.querySelector('[name="thankyou_message"]');
    if(t && t.parentNode) t.parentNode.removeChild(t);
  }
  // --- fim M2

  // o form do RD e criado depois que a lib carrega (uma vez so, mesmo com varios forms na pagina)
  function createRd(){
    new RDStationForms(box.getAttribute('data-rd-form'), box.getAttribute('data-rd-token')).createForm();
  }
  if(window.RDStationForms){ createRd(); }
  else {
    var s = document.createElement('script');
    s.src = RD_LIB; s.async = true; s.onload = createRd;
    document.head.appendChild(s);
  }

  // --- identidade da campanha: le da URL e guarda na sessao (sobrevive a recarga)
  var qs = new URLSearchParams(location.search);
  var KEYS = ['mc_id','utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  KEYS.forEach(function(k){
    var v = qs.get(k);
    if(v) try{ sessionStorage.setItem('zr_'+k, v); }catch(e){}
  });
  function ident(k){ try{ return sessionStorage.getItem('zr_'+k) || ''; }catch(e){ return ''; } }

  // event_id compartilhado: o mesmo valor vai no pixel e, via campo do RD, no CAPI pelo n8n.
  // E o que permite a Meta deduplicar navegador vs servidor (senao cada lead conta 2x).
  var eventId = 'lead_' + (ident('mc_id') || 'org') + '_' +
                Date.now().toString(36) + Math.random().toString(36).slice(2,8);

  function fillHidden(){
    KEYS.concat(['event_id']).forEach(function(k){
      var v = (k === 'event_id') ? eventId : ident(k);
      if(!v) return;
      var el = box.querySelector('[name="'+k+'"], [name*="'+k+'"], #'+k);
      if(el){ el.value = v; fire(el,'input'); fire(el,'change'); }
    });
  }
  // --- fim identidade

  function rdName(){ return box.querySelector('input[name="name"], input[name="nome"], input[name*="name"]:not([type=hidden])'); }
  function rdEmail(){ return box.querySelector('input.js-email, input[type=email], input[name=email]'); }
  // telefone: campo padrao do RD (celular ou telefone) ou um campo personalizado com "whats"/"phone"
  function rdPhone(){
    return box.querySelector('input[name="mobile_phone"], input[name="personal_phone"], input[type=tel], ' +
                             'input[name*="phone"], input[name*="celular"], input[name*="whats"]');
  }
  function rdSubmit(){ return box.querySelector('button[type=submit], input[type=submit], .bricks--component-button'); }
  function fire(el, name){ el.dispatchEvent(new Event(name, {bubbles:true})); }

  // (11) 91234-5678
  function maskPhone(v){
    var d = v.replace(/\D/g,'').slice(0,11);
    if(d.length <= 2) return d.length ? '(' + d : '';
    if(d.length <= 6) return '(' + d.slice(0,2) + ') ' + d.slice(2);
    if(d.length <= 10) return '(' + d.slice(0,2) + ') ' + d.slice(2,6) + '-' + d.slice(6);
    return '(' + d.slice(0,2) + ') ' + d.slice(2,7) + '-' + d.slice(7);
  }

  // Link do grupo (campanha) na tela de sucesso, depois do cadastro. /grupo e um redirect da loja: nao mexer nele.
  function addGroupLink(d){
    if(d.querySelector('a.zv-grupo')) return;
    var a = document.createElement('a');
    a.className = 'zv-grupo'; a.href = '/grupo'; a.textContent = 'zaiare.com.br/grupo';
    a.style.cssText = 'color:inherit;text-decoration:underline;font-weight:600';
    a.addEventListener('click', function(){ track('grupo_click', {area: 'success'}); });
    d.appendChild(document.createElement('br'));
    d.appendChild(document.createTextNode('Entre também no nosso grupo: '));
    d.appendChild(a);
  }

  function markAllDone(msg){
    wraps.forEach(function(w){
      var f = w.querySelector('form'), l = w.querySelector('.zv-vipf__lgpd'), d = w.querySelector('.zv-vipf__done');
      if(f) f.hidden = true;               // o CSS [hidden] e quem faz isso valer
      if(l) l.hidden = true;               // o aviso de consentimento nao serve mais depois do sim
      if(d){ if(msg) d.textContent = msg; addGroupLink(d); d.hidden = false; }
    });
  }

  // --- avisos na propria pagina (confirmacao, erro de envio e e-mail repetido)
  // E-mail repetido: o RD nao recusa e-mail que ja existe (so atualiza o contato), entao a pagina
  // lembra, neste navegador, dos e-mails que ja enviou com sucesso e avisa em vez de reenviar.
  var SEEN_KEY = 'zv_vip_emails';
  function seenList(){ try{ return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'); }catch(e){ return []; } }
  function wasSeen(mail){ return seenList().indexOf(mail.toLowerCase()) !== -1; }
  function remember(mail){
    try{
      var l = seenList(); mail = mail.toLowerCase();
      if(l.indexOf(mail) === -1){ l.push(mail); localStorage.setItem(SEEN_KEY, JSON.stringify(l.slice(-20))); }
    }catch(e){}
  }
  // O aviso usa o paragrafo do consentimento (LGPD) que ja esta no layout: nao cria elemento novo.
  function note(wrap, msg){
    var l = wrap.querySelector('.zv-vipf__lgpd');
    if(!l) return;
    if(!l.hasAttribute('data-orig')) l.setAttribute('data-orig', l.textContent);
    if(msg){
      l.textContent = msg; l.style.opacity = '1'; l.style.fontWeight = '600'; l.setAttribute('role', 'alert');
    } else {
      l.textContent = l.getAttribute('data-orig'); l.style.opacity = ''; l.style.fontWeight = ''; l.removeAttribute('role');
    }
  }
  var MSG_DUP = 'Atenção: este e-mail já foi cadastrado. Confira sua caixa de entrada (e o spam) para confirmar seu lugar.';
  var MSG_FAIL = 'Atenção: não conseguimos enviar seu cadastro. Confira sua conexão e tente de novo.';
  function failMsg(detail){
    var body = (detail && detail.body) || '';
    return /j[aá] (cadastrad|existe|inscrit)|already|exist|duplic/i.test(body) ? MSG_DUP : MSG_FAIL;
  }
  // --- fim avisos

  // Evento de lead para o Custom Pixel da loja (que repassa ao PostHog e ao GA4 com o mesmo nome).
  // Dispara uma vez, so quando o RD confirma o envio. Nao leva nome, e-mail nem telefone.
  function track(name, props){
    try{
      if(typeof window.zvTrack === 'function'){ window.zvTrack(name, props); }
      else if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){ Shopify.analytics.publish(name, props); }
    }catch(e){}
  }
  function where(w){ return w.classList.contains('zv-vipf--hero') ? 'hero' : (w.closest('#lista-vip') ? 'bottom' : 'other'); }
  function trackLead(w){ track('generate_lead', {content_name: 'lista-vip', form_location: where(w)}); }

  wraps.forEach(function(wrap){
    var form = wrap.querySelector('form');
    var name = wrap.querySelector('input[name=name]');
    var email = wrap.querySelector('input[type=email]');
    var phone = wrap.querySelector('input[type=tel]');
    var btn = wrap.querySelector('button[type=submit]');
    if(!form || !email || !btn) return;
    var LABEL = btn.textContent;

    if(phone){
      phone.addEventListener('input', function(){ phone.value = maskPhone(phone.value); });
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(name){
        name.value = name.value.trim();
        if(!name.checkValidity()){ name.reportValidity(); return; }
      }
      if(!email.checkValidity()){ email.reportValidity(); return; }
      if(phone){
        var digits = phone.value.replace(/\D/g,'');
        phone.setCustomValidity(digits.length >= 10 ? '' : 'Coloque o WhatsApp com DDD.');
        if(!phone.checkValidity()){ phone.reportValidity(); return; }
      }
      note(wrap, '');
      if(wasSeen(email.value.trim())){ note(wrap, MSG_DUP); track('vip_form_error', {reason: 'duplicate', form_location: where(wrap)}); return; }
      var re = rdEmail(), rs = rdSubmit();
      if(!re || !rs){ note(wrap, MSG_FAIL); track('vip_form_error', {reason: 'form_unavailable', form_location: where(wrap)}); btn.disabled = true; btn.textContent = '…'; setTimeout(function(){ btn.disabled=false; btn.textContent=LABEL; }, 1500); return; }
      re.value = email.value; fire(re,'input'); fire(re,'change');
      if(name){
        var rn = rdName();
        if(rn){ rn.value = name.value; fire(rn,'input'); fire(rn,'change'); }
        else if(window.console) console.warn('[Zaiare] o form do RD ainda nao tem campo de nome: o nome nao foi enviado.');
      }
      if(phone){
        var rp = rdPhone();
        if(rp){ rp.value = phone.value; fire(rp,'input'); fire(rp,'change'); }
        else if(window.console) console.warn('[Zaiare] o form do RD ainda nao tem campo de telefone: o WhatsApp nao foi enviado.');
      }
      btn.disabled = true; btn.textContent = '…';
      fillHidden();
      killThankyou();
      if(window.fbq) fbq('track','Lead',{content_name:'lista-vip'},{eventID:eventId});
      rs.click();
      var settled = false;
      var firstName = name ? name.value.trim().split(/\s+/)[0] : '';
      function doneMsg(){
        return 'Pronto' + (firstName ? ', ' + firstName : '') + '! Recebemos o seu cadastro. Enviamos um e-mail de confirmação para ' +
               email.value.trim() + '. Confirme para garantir seu lugar na lista VIP.';
      }
      var obs = new MutationObserver(function(){
        var t = (box.textContent || '');
        if(/obrigad|sucesso|confirm|lista|recebemos/i.test(t)) ok();
      });
      function ok(){ if(settled) return; settled = true; obs.disconnect(); remember(email.value.trim()); trackLead(wrap); markAllDone(doneMsg()); }
      function retry(detail){ if(settled) return; settled = true; obs.disconnect(); btn.disabled = false; btn.textContent = LABEL; var fm = failMsg(detail); note(wrap, fm); track('vip_form_error', {reason: fm === MSG_DUP ? 'duplicate' : 'send_failed', form_location: where(wrap)}); }

      // sinal primario: a propria resposta do XHR do RD (ver o patch la em cima).
      // O MutationObserver fica so como rede secundaria — com o redirect removido, o RD nao
      // escreve mais nada de "obrigado" na tela, entao ele sozinho nunca confirmaria.
      document.addEventListener('zr:rd-done', function(e){
        if(e.detail && e.detail.ok) ok(); else retry(e.detail);
      }, {once:true});

      obs.observe(box, {childList:true, subtree:true, characterData:true});
      // ultima rede: se nao vier nem resposta nem mutacao, reabilita p/ nova tentativa — SEM falso "pronto"
      setTimeout(function(){ retry(); }, 8000);
    });
  });
})();
